"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("webmotors-react-pj/utils");
var _style = require("webmotors-react-pj/frame/header/logged/items/user/info/style");
var _icon = _interopRequireDefault(require("webmotors-react-pj/frame/header/logged/items/user/icon"));
var _default = () => {
  const jwt = (0, _utils.jwtGet)();
  return _react.default.createElement(_style.StyleWrapper, null, _react.default.createElement("div", null, _react.default.createElement(_icon.default, {
    open: true,
    size: 64
  }, jwt.nameid && jwt.nameid[0] || '🛱')), _react.default.createElement(_style.StyleUser, null, _react.default.createElement(_style.StyleName, null, jwt.nameid), _react.default.createElement(_style.StyleEmail, null, jwt.email)));
};
exports.default = _default;